import { useState } from 'react';
import { Modal } from '@mantine/core';

import { FilledButton, OutlinedButton } from 'components/common/Button/Button';
import Filter from 'components/common/Inputs/Filter/Filter';
import {
   clientTypesOptions,
   facilitateAccessOptions,
   salonTypesOptions,
} from 'constants/filterOptions';
import classes from './AdditionalFiltersModal.module.css';
import useTranslation from 'next-translate/useTranslation';
import {AnnouncementFilters, AnnouncementFiltersKey} from "../Filters";

type AdditionalFiltersModalProps = {
   filterValues: AnnouncementFilters;
   filterValueChangeHandler: (filterName: AnnouncementFiltersKey, value: string) => void;
   opened: boolean;
   onClose: () => void;
   onApplyFiltersValues: () => void;
   onClearFiltersValues: () => void;
};

const AdditionalFiltersModal = ({
   filterValues,
   filterValueChangeHandler,
   opened,
   onClose,
   onApplyFiltersValues,
   onClearFiltersValues,
}: AdditionalFiltersModalProps) => {
   const { t } = useTranslation('common');
   const [openFilters, setOpenFilters] = useState<{ [key: string]: boolean }>({
      clientTypes: false,
      typeOfSalons: false,
      facilitateAccess: false,
   });

   const clearValuesHandler = () => {
      onClearFiltersValues();
      onClose();
      setOpenFilters({ clientTypes: false, typeOfSalons: false, facilitateAccess: false });
   };

   const applyValuesHandler = () => {
      onApplyFiltersValues();
      onClose();
      setOpenFilters({ clientTypes: false, typeOfSalons: false, facilitateAccess: false });
   };

   const clickToggleHandler = (filterName: string, openValue: boolean) => {
      setOpenFilters({
         ...{ clientTypes: false, typeOfSalons: false, facilitateAccess: false },
         [filterName]: openValue,
      });
   };

   return (
      <Modal
         className={classes.modalContainer}
         centered
         size={390}
         overlayOpacity={0.45}
         opened={opened}
         onClose={onClose}
         title={t('additional_filters')}
      >
         <div className={classes.modalContent}>
            <ul>
               <li>
                  <Filter
                     filterType="checkbox"
                     selectedOptions={filterValues.clientTypes as string[]}
                     onChangeHandler={filterValueChangeHandler}
                     options={clientTypesOptions}
                     placeholder={t('massage_for')}
                     filterName="clientTypes"
                     closeOnClickOutside={false}
                     isFilterOpen={openFilters.clientTypes}
                     onClickToggle={clickToggleHandler}
                     expandedInPlace
                  />
               </li>
               <li>
                  <Filter
                     filterType="checkbox"
                     selectedOptions={filterValues.typeOfSalons as string[]}
                     onChangeHandler={filterValueChangeHandler}
                     options={salonTypesOptions}
                     placeholder={t('facility_type')}
                     filterName="typeOfSalons"
                     closeOnClickOutside={false}
                     isFilterOpen={openFilters.typeOfSalons}
                     onClickToggle={clickToggleHandler}
                     expandedInPlace
                  />
               </li>
               <li>
                  <Filter
                     filterType="checkbox"
                     selectedOptions={filterValues.facilitateAccess as string[]}
                     onChangeHandler={filterValueChangeHandler}
                     options={facilitateAccessOptions}
                     placeholder={t('access_facilities')}
                     filterName="facilitateAccess"
                     closeOnClickOutside={false}
                     isFilterOpen={openFilters.facilitateAccess}
                     onClickToggle={clickToggleHandler}
                     expandedInPlace
                  />
               </li>
            </ul>
            <div className={classes.buttonsSection}>
               <FilledButton content={t('apply_filters')} onClick={applyValuesHandler} />
               <OutlinedButton onClick={clearValuesHandler} content={t('clear')} />
            </div>
         </div>
      </Modal>
   );
};

export default AdditionalFiltersModal;
